import { render, staticRenderFns } from "./UiCountdown.vue?vue&type=template&id=71c9180e&lang=pug&"
import script from "./UiCountdown.vue?vue&type=script&lang=js&"
export * from "./UiCountdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports